/**
 * El naranja de la guía de puesta en marcha, en un solo sitio.
 *
 * El acceso a la guía aparece en dos lugares que el usuario nunca ve a la vez —el
 * lateral en escritorio y la barra flotante en móvil y tablet— y tienen que leerse
 * como la MISMA cosa. Con el color escrito a mano en cada archivo ya habían
 * divergido: el lateral iba en azul corporativo (el color de todo lo demás del menú,
 * o sea invisible) y la barra flotante en el degradado turquesa→azul de la cabecera.
 *
 * Naranja a propósito: es el único elemento de la aplicación que lo usa, así que no
 * compite con nada y se encuentra sin buscarlo. Y sobre naranja el texto va en
 * blanco, no en el gris de siempre.
 */

/** Fondo sólido del acceso a la guía. */
export const ONBOARDING_ORANGE = "linear-gradient(145deg,#F97316 0%,#EA580C 100%)";

/** Sombra proyectada en el mismo tono; una sombra gris lo apagaría. */
export const ONBOARDING_ORANGE_SHADOW = "0 10px 24px rgba(234,88,12,0.34)";
